<template>
  <div>
    <h3 class="dashboard-header" style="">Target Races</h3>
    <hr>
    <!-- {{user}} -->
    <!-- {{ targetRaces }} -->

    <div v-for="race in targetRaces" :key="race.id" @click="showEditModal(race)" style="cursor: pointer;">
      <div class="pt-3 pb-1 px-2" :class="{  }" style="/*border-bottom: 1px solid var(--bootstrapgrey);*/">
      <!-- <div @click="toggleEditForm(race)"> -->
        <!-- {{ race.race_name }}
        {{ race.date }} -->
        <!-- <small @click="showEditModal(race)" style="cursor: pointer;">{{ race.humandate }} <img src="../../../assets/img/icons/pencil_icon.svg" width='13px' alt="edit" class='ml-1 mb-1' style="" id=""></small> -->
        <div class="row">
          <div class="col-lg-6">
            <h3 v-if="race.race_link"><a :href="race.race_link" target="_blank">{{ race.race_name }}</a>
              <!-- <img @click="showEditModal(race)" src="../../../assets/img/icons/pencil_icon.svg" width='13px' alt="edit" class='ml-1' style="cursor: pointer;" id=""> -->
            </h3>
            <h3 v-if="!race.race_link">{{ race.race_name }}
              <!-- <img @click="showEditModal(race)" src="../../../assets/img/icons/edit_icon_simple.svg" width='13px' alt="edit" class='ml-2 mb-1' style="cursor: pointer;" id=""> -->
            </h3>
            <div class="">
              <div class="">
                <h5>
                  <span v-if="race.race_type || race.time_total" class="mr-3" style="">
                    {{ race.race_type }}<span v-if="race.time_total"> - {{ race.time_hours }}:{{ race.time_minutes | twoDigits }}:<span v-if="race.time_seconds != 0 && race.time_seconds != null">{{ race.time_seconds | singleDecimalSeconds }}</span><span v-if="race.time_seconds == 0">00</span></span>
                  </span>
                </h5>
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <h3 style="text-align: right; font-weight: 700; color: ;">{{ race.daystilrace }} Days</h3>
            <h5 style="text-align: right; ">{{ race.humandate }}</h5>
          </div>
        </div>

        <!-- <p v-html="rawHtml">{{ race.notes }}</p> -->
        <p v-if="race.notes">{{race.notes}}</p>
        <!-- <span v-html="race.notes"></span> -->
        <!-- {{ race.race_link }} -->
      </div>
      <hr>
    </div>
    <!-- {{ targetRaces }} -->
    <button v-if="!targetRaces[0]" class="btn btn-primary mt-2" @click="showModal">+ Add Target Race</button>
    <button v-if="targetRaces[0]" class="btn btn-primary mt-2" @click="showModal">+</button>

    <!-- Add Race Form -->
    <!-- <div class="accordion mt-2">
      <div class="header" style="padding-left: 12px;" v-on:click="toggle">
        <slot name="header">+ Add Target Race</slot>
        <i class="fa fa-2x fa-angle-down header-icon" v-bind:class="{ rotate: show }"></i>
      </div>
      <transition name="accordion"
        v-on:before-enter="beforeEnter" v-on:enter="enter"
        v-on:before-leave="beforeLeave" v-on:leave="leave">
        <div class="body" v-show="show">
          <div class="body-inner">
            <form action="">
              <div class="form-row">
                <div class="form-group col-md-6" :class="{ invalid: $v.raceName.$invalid && saveClicked }">
                  <label for="raceName">Race Name*</label>
                  <input type="text" class="form-control" id="raceName" placeholder="What's the name of the event?" v-model="raceName">
                  <small v-if="$v.raceName.$invalid && saveClicked">A race name is required.</small>
                </div>
              </div>

              <button class="btn btn-primary" @click.prevent="saveRace">Save</button>
            </form>
          </div>
        </div>
      </transition>
    </div> -->
    <!-- End of ADD RACE form -->

    <!-- ---- TARGET RACE MODAL ---- -->
    <!-- Need to raise the z-index above the sticky side bar (which is something like 1200) -->
    <modal name="target-race" width="90%" height="auto" :scrollable='true' class="" style="z-index: 9999;">
      <div class="p-4">
        <h4 v-if="!editing" style="">Add Target Race</h4>
        <h4 v-if="editing" style="">Edit {{ raceName }}</h4>
        <form action="" class="">
          <div class="form-row">
            <div class="form-group col-md-6" :class="{ invalid: $v.raceName.$invalid && saveClicked }">
              <label for="raceName">Race Name*</label>
              <input type="text" class="form-control" id="raceName" placeholder="What's the name of the event?" v-model="raceName">
              <small v-if="$v.raceName.$invalid && updateClicked">A race name is required.</small>
            </div>
            <div class="form-group col-md-6" :class="{ invalid: $v.raceDate.$invalid && saveClicked }">
              <label for="raceDate">Race Date*</label>
              <!-- <div style="line-height: 1;">
                <small>Si no tienes todavía una fecha de inicio, deja este campo en blanco</small>
              </div> -->
              <!-- https://www.npmjs.com/package/vuejs-datepicker -->
              <!-- https://codesandbox.io/s/mpklq49wp -->
              <datepicker class="form-control" placeholder="Select Date" v-model="raceDate" style="padding: .37rem .75rem; line-height: 1;"></datepicker>
              <small v-if="$v.raceDate.$invalid && saveClicked">The race date is required.</small>
            </div>
            <!-- ---- INSIDE EDIT RACE MODAL ---- -->
            <!-- <div class="form-group col-md-3">
              <label for="raceType">Race Type</label>
              <select class="form-control" id="raceType" v-model="raceType">
                <option>5k</option>
                <option>10k</option>
                <option>Half Marathon</option>
                <option>Marathon</option>
                <option>Custom</option>
              </select>
            </div> -->
          </div>

          <div class="form-row">
            <!-- <div class="form-group col-md-6">
              <label for="raceLink">Race Link</label>
              <input type="text" class="form-control" id="raceLink" placeholder="Link to the race info page" v-model="raceLink">
            </div> -->
            <div class="form-group col-md-6">
              <label for="raceType">Race Type</label>
              <select class="form-control" id="raceType" v-model="raceType">
                <option>5k</option>
                <option>10k</option>
                <option>Half Marathon</option>
                <option>Marathon</option>
                <option>Custom</option>
              </select>
            </div>
            <!-- <div class="form-group col-md-6">
              <label for="raceType">Race Type</label>
              <select class="form-control" id="raceType" v-model="raceType">
                <option>5k</option>
                <option>10k</option>
                <option>Half Marathon</option>
                <option>Marathon</option>
                <option>Custom</option>
              </select>
            </div> -->
            <div class="col-md-4">
              <label for="">Target Time</label>
              <!-- <div class="form-row">
                <div class="col-lg-4 col-md-4 input-group" style="padding-right: 0;">
                  <input type="number" class="form-control" id="" placeholder="hours" v-model="hours" style="border-top-right-radius: 0; border-bottom-right-radius: 0;">
                  <div class="input-group-append">
                    <span class="input-group-text" id="basic-addon1" style="border-top-right-radius: 0; border-bottom-right-radius: 0; border-right-width: 0;">:</span>
                  </div>
                </div>
                <div class="col-lg-4 col-md-4 input-group" style="padding-left: 0; padding-right: 0;">
                  <input type="number" class="form-control" id="" placeholder="mins" v-model="minutes" style="border-top-left-radius: 0; border-bottom-left-radius: 0;">
                  <div class="input-group-append">
                    <span class="input-group-text" id="basic-addon1" style="border-top-right-radius: 0; border-bottom-right-radius: 0; border-right-width: 0;">:</span>
                  </div>
                </div>
                <div class="col-lg-4 col-md-4" style="padding-left: 0; padding-right: 30px;">
                  <input type="number" class="form-control" id="" placeholder="secs" v-model="seconds" style="border-top-left-radius: 0; border-bottom-left-radius: 0;">
                </div>
              </div> -->
              <div class="input-group">
                <input type="number" class="form-control" id="" placeholder="hours" v-model="hours" style="border-top-right-radius: 0; border-bottom-right-radius: 0;">
                <div class="input-group-append">
                  <span class="input-group-text" id="basic-addon1" style="border-top-right-radius: 0; border-bottom-right-radius: 0; border-right-width: 0;">:</span>
                </div>
                <input type="number" class="form-control" id="" placeholder="mins" v-model="minutes" style="border-top-left-radius: 0; border-bottom-left-radius: 0;">
                <div class="input-group-append">
                  <span class="input-group-text" id="basic-addon1" style="border-top-right-radius: 0; border-bottom-right-radius: 0; border-right-width: 0;">:</span>
                </div>
                <input type="number" class="form-control" id="" placeholder="secs" v-model="seconds" style="border-top-left-radius: 0; border-bottom-left-radius: 0;">
              </div>

            </div>
          </div>
          <!-- Allow the user to enter a race distance and units if it isn't one of the standard lengths -->
          <div class="form-row" v-if="raceType == 'Custom'">
            <div class="form-group col-md-6">
              <!-- <label for="raceDistance">Distance</label> -->
              <input type="text" class="form-control" id="raceDistance" placeholder="Distance" v-model="raceDistance">
              <!-- <small v-if="$v.raceName.$invalid && saveClicked">A race name is required.</small> -->
            </div>
            <div class="form-group col-md-6" style="max-width: 100px;">
              <select class="form-control" id="" v-model="distanceUnits">
                <option>km</option>
                <option>mi</option>
              </select>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-6">
              <label for="raceLink">Race Link</label>
              <input type="text" class="form-control" id="raceLink" placeholder="Link to the race info page" v-model="raceLink">
            </div>
          </div>
          <!-- ---- INSIDE EDIT RACE MODAL ---- -->
          <!-- <div class="form-row">
            <div class="form-group col-md-12">
              <label for="notes">Notes</label>
              <textarea class="form-control" id="notes" rows="3" v-model="notes" placeholder="Anything notworthy about the event or your performance! Weather conditions, any injuries you experienced or were dealing with, people you met, things you learned, etc."></textarea>
            </div>
          </div> -->
          <hr>
          <div v-if="editing" class="web-only">
            <button class="btn btn-info mr-1 mt-2" @click.prevent="closeModal">Cancel</button><button class="btn btn-danger mr-1 mt-2" @click.prevent="deleteRace(editRace.id)" style="">Delete Race</button><button class="btn btn-primary mt-2 mb-4" @click.prevent="updateRace(editRace.id)" style="float: right;">Update Race</button>
          </div>
          <div v-if="editing" class="mobile-only">
            <button class="btn btn-info mr-1 mt-2" @click.prevent="closeModal">Cancel</button><button class="btn btn-danger mr-1 mt-2" @click.prevent="deleteRace(editRace.id)" style="">Delete</button><button class="btn btn-primary mt-2 mb-4" @click.prevent="updateRace(editRace.id)" style="float: right;">Update</button>
          </div>
          <div v-if="!editing">
            <button class="btn btn-info mr-1" @click.prevent="closeModal">Cancel</button><button class="btn btn-primary" @click.prevent="saveRace()" style="float: right;">Save Race</button>
          </div>
        </form>
      </div>
    </modal>
  </div>
</template>

<script>
  import axios from 'axios'
  import { required } from 'vuelidate/lib/validators'; // Validators pre built into vuelidate - lecture 373
  import Datepicker from 'vuejs-datepicker'; // https://www.npmjs.com/package/vuejs-datepicker

  export default {
    props: ['user'],
    data () {
      return {
        editing: false,
        raceName: '',
        raceDate: '',
        raceDistance: null,
        distanceUnits: '',
        raceType: '',
        hours: null,
        minutes: null,
        seconds: null,
        totalTime: null,
        raceLink: '',
        notes: '',
        saveClicked: false,
        updateClicked: false,
        user: null,
        targetRaces: [],
        editRace: null,
      }
    },
    validations: {
      raceName: {
        required,
      },
      raceDate: {
        required,
      },
    },
    components: {
      Datepicker // https://www.npmjs.com/package/vuejs-datepicker
    },
    created () {
      this.getUserProfile();
    },
    methods: {
      getUserProfile () {
        // this.$store.dispatch('getUser').then(() => { // Lecture 360
        //   this.user = this.$store.getters.user
        //   this.distanceUnits = this.user.preferred_distance_units
        //   console.log(this.$store.getters.user)
        //   this.getTargetRaces();
        // })
        this.distanceUnits = this.user.preferred_distance_units
        this.getTargetRaces();
      },
      getTargetRaces () {
        axios.get('/api/targetraces/?user='.concat(this.user.id.toString()))
          .then(res => {
            console.log(res)
            this.targetRaces = res.data

            const oneDay = 24 * 60 * 60 * 1000
            let today = new Date()
            // https://tecadmin.net/get-current-date-time-javascript/
            // console.log(today.getHours())
            // console.log(today.getMinutes())
            // console.log(today.getSeconds())
            let hourNow = today.getHours()
            // https://stackoverflow.com/questions/18889548/javascript-change-gethours-to-2-digit
            // Need to make sure each of these values is 2 digits, otherwise it breaks the human date generation below
            hourNow = ("0" + hourNow).slice(-2);
            let minuteNow = today.getMinutes()
            minuteNow = ("0" + minuteNow).slice(-2);
            let secondNow = today.getMinutes()
            secondNow = ("0" + secondNow).slice(-2);

            for (var race in this.targetRaces) {
              // console.log(this.targetRaces[race].date)
              // console.log(this.targetRaces[race].date.concat('T').concat(hourNow).concat(':').concat(minuteNow).concat(':').concat(secondNow))
              // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date
              // let raceDate = new Date(this.targetRaces[race].date.concat('T').concat(today.getHours()).concat(':').concat(today.getMinutes()).concat(':').concat(today.getSeconds()))
              let raceDate = new Date(this.targetRaces[race].date.concat('T').concat(hourNow).concat(':').concat(minuteNow).concat(':').concat(secondNow))
              // https://stackoverflow.com/questions/26528085/javascript-date-method-without-time
              // console.log(new Date(this.targetRaces[race].date.concat('T').concat(today.getHours()).concat(':').concat(today.getMinutes()).concat(':').concat(today.getSeconds())).toDateString())
              // console.log(new Date(raceDate).toDateString())
              // Add the date better formatted for humans to each race object
              // https://stackoverflow.com/questions/1168807/how-can-i-add-a-key-value-pair-to-a-javascript-object
              // this.targetRaces[race].humandate = new Date(this.targetRaces[race].date.concat('T').concat(today.getHours()).concat(':').concat(today.getMinutes()).concat(':').concat(today.getSeconds())).toDateString()
              this.targetRaces[race].humandate = new Date(raceDate).toDateString()

              // --- CALCULATE THE DAYS REMAINING UNTIL THE TARGET RACE
              // https://stackoverflow.com/questions/2627473/how-to-calculate-the-number-of-days-between-two-dates
              // https://stackoverflow.com/questions/2698725/comparing-date-part-only-without-comparing-time-in-javascript
              // console.log(Math.round((raceDate - today) / oneDay))
              this.targetRaces[race].daystilrace = Math.round((raceDate - today) / oneDay)

              // The seconds field in Django is stored with decimals, just dropping those
              this.targetRaces[race].time_seconds = parseInt(this.targetRaces[race].time_seconds)
            }

            // https://flaviocopes.com/how-to-sort-array-of-objects-by-property-javascript/
            // https://stackoverflow.com/questions/2466356/javascript-object-list-sorting-by-object-property
            // Sort the target races so that the sooner ones are listed first
            this.targetRaces = this.targetRaces.sort((a, b) => (a.daystilrace > b.daystilrace) ? 1 : -1)
          })
          .catch(error => console.log(error))
      },
      calculateDistance () {
        //
        // Figure out the race distance for common, pre-defined race types
        //
        console.log('Calculating distance!')
        console.log(this.distanceUnits)
        if (this.raceType == 'Custom') {
          return
        } else if (this.raceType == '5k' && this.distanceUnits == 'km') {
          this.raceDistance = 5;
        } else if (this.raceType == '5k' && this.distanceUnits == 'mi') {
          this.raceDistance = 3.1;
        } else if (this.raceType == '10k' && this.distanceUnits == 'km') {
          this.raceDistance = 10;
        } else if (this.raceType == '10k' && this.distanceUnits == 'mi') {
          this.raceDistance = 6.2;
        } else if (this.raceType == 'Half Marathon' && this.distanceUnits == 'km') {
          this.raceDistance = 21.1;
        } else if (this.raceType == 'Half Marathon' && this.distanceUnits == 'mi') {
          this.raceDistance = 13.1;
        } else if (this.raceType == 'Marathon' && this.distanceUnits == 'km') {
          this.raceDistance = 42.2;
        } else if (this.raceType == 'Marathon' && this.distanceUnits == 'mi') {
          this.raceDistance = 26.2;
        } else {
          return
        }
      },
      calculateTotalTime() {
        // let totalTime = null
        this.totalTime = null
        if (this.hours) {
          this.totalTime += this.hours * 3600
        }
        if (this.minutes) {
          this.totalTime += this.minutes * 60
        }
        if (this.seconds) {
          this.totalTime += this.seconds
        }
      },
      saveRace () {
        this.saveClicked = true
        console.log(this.raceDate)
        // console.log(this.raceDate.format("isoDate"))
        // let options = { year: 'numeric',  }
        let options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        console.log(this.raceDate.toLocaleDateString("en-US", options)); // 9/17/2016

        if (!this.distanceUnits){
          this.distanceUnits = this.user.preferred_distance_units
        }

        // if (this.raceType == '5k')
        this.calculateDistance();
        this.calculateTotalTime();

        console.log(this.raceName)
        console.log(this.raceDate.toLocaleDateString("en-US", options))
        console.log(this.raceType)
        console.log(this.raceDistance)
        console.log(this.distanceUnits)
        console.log(this.hours)
        console.log(this.minutes)
        console.log(this.seconds)
        console.log(Math.round(this.totalTime * 100) / 100)
        // console.log(this.overallRank)
        // console.log(this.overallCompetitors)
        // console.log(this.ageRank)
        // console.log(this.ageCompetitors)
        console.log(this.raceLink)
        // console.log(this.resultsLink)
        console.log(this.notes)
        // console.log(this.personalBest)

        axios.post('/api/targetraces/',
          {
            user: this.user.id, // https://stackoverflow.com/questions/39001486/posting-a-foreign-key-relationship-in-django-rest-framework
            race_name: this.raceName,
            // date: this.raceDate,
            // https://docs.djangoproject.com/en/2.2/ref/forms/fields/#datefield
            date: this.raceDate.toLocaleDateString("en-US", options), // https://stackoverflow.com/questions/3552461/how-to-format-a-javascript-date, https://www.django-rest-framework.org/api-guide/fields/#datefield
            // date: '10/01/2019', // This is the kind of format the above expression is outputting
            // date: '2019-01-29', // This is the default format django rest framework expects
            race_type: this.raceType,
            distance: this.raceDistance,
            distance_units: this.distanceUnits,
            time_hours: this.hours,
            time_minutes: this.minutes,
            time_seconds: this.seconds,
            time_total: this.totalTime,
            // overall_rank: this.overallRank,
            // overall_competitors: this.overallCompetitors,
            // age_rank: this.ageRank,
            // age_competitors: this.ageCompetitors,
            race_link: this.raceLink,
            // results_link: this.resultsLink,
            notes: this.notes,
            // personal_best: this.personalBest,
          }
        )
          .then(res => {
            console.log(res)
            this.getTargetRaces() // Refresh the list of races after adding a new one
            this.clearRaceForm()
            this.closeModal() // Close the target race modal
            this.saveClicked = false
          })
          .catch(error => console.log(error))
      },
      updateRace (raceID) {
        console.log('Updating race: '.concat(raceID.toString()))
        this.updateClicked = true

        if (!this.distanceUnits){
          this.distanceUnits = this.user.preferred_distance_units
        }

        this.calculateDistance();
        this.calculateTotalTime();
        console.log(this.raceDate)
        console.log(new Date(this.raceDate))
        // When pulling the date from the database, it's in the YYYY-MM-DD format
        // So when we try to run toLocaleDateString on it, it doesn't work because it expects a javascript date object
        // So we convert the date to a javascript date object to ensure we can convert it back without issues later
        this.raceDate = new Date(this.raceDate)
        let options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        console.log(this.raceDate.toLocaleDateString("en-US", options));

        console.log(this.raceName)
        console.log(this.raceDate.toLocaleDateString("en-US", options))
        console.log(this.raceType)
        console.log(this.raceDistance)
        console.log(this.distanceUnits)
        console.log(this.hours)
        console.log(this.minutes)
        console.log(this.seconds)
        console.log(Math.round(this.totalTime * 100) / 100)
        // console.log(this.overallRank)
        // console.log(this.overallCompetitors)
        // console.log(this.ageRank)
        // console.log(this.ageCompetitors)
        console.log(this.raceLink)
        // console.log(this.resultsLink)
        console.log(this.notes)
        // console.log(this.personalBest)

        axios.patch('/api/targetraces/'.concat(raceID.toString()).concat('/'),
          {
            race_name: this.raceName,
            date: this.raceDate.toLocaleDateString("en-US", options), // https://stackoverflow.com/questions/3552461/how-to-format-a-javascript-date, https://www.django-rest-framework.org/api-guide/fields/#datefield
            race_type: this.raceType,
            distance: this.raceDistance,
            distance_units: this.distanceUnits,
            time_hours: this.hours,
            time_minutes: this.minutes,
            time_seconds: this.seconds,
            // When the total time is calculated, it outputs some weird floating point number
            time_total: Math.round(this.totalTime * 100) / 100, // https://stackoverflow.com/questions/11832914/round-to-at-most-2-decimal-places-only-if-necessary
            // overall_rank: this.overallRank,
            // overall_competitors: this.overallCompetitors,
            // age_rank: this.ageRank,
            // age_competitors: this.ageCompetitors,
            race_link: this.raceLink,
            // results_link: this.resultsLink,
            notes: this.notes,
            // personal_best: this.personalBest,

            // user: 2 // Hard coded this here because I accidentally saved stuff to the wrong user and didn't want to enter it again
          }
        )
          .then(res => {
            console.log(res)
            this.getTargetRaces() // Refresh the list of races after editing one
            this.clearRaceForm()
            this.closeModal() // Close the edit race modal
            this.updateClicked = false
          })
          .catch(error => {
            console.log(error)
          })
      },
      showModal() {
        this.editing = false
        this.$modal.show('target-race'); // npmjs.com/package/vue-js-modal
      },
      showEditModal(race) {
        this.editing = true

        this.editRace = race
        this.raceName = race.race_name
        this.raceDate = race.date
        this.raceDate = new Date(this.raceDate)
        this.raceType = race.race_type
        this.raceDistance = race.distance
        this.distanceUnits = race.distance_units
        this.hours = race.time_hours
        this.minutes = race.time_minutes
        this.seconds = race.time_seconds
        this.totalTime = race.time_total
        // this.overallRank = race.overall_rank
        // this.overallCompetitors = race.overall_competitors
        // this.ageRank = race.age_rank
        // this.ageCompetitors = race.age_competitors
        this.raceLink = race.race_link
        // this.resultsLink = race.results_link
        this.notes = race.notes;
        // this.personalBest = race.personal_best;
        this.$modal.show('target-race'); // npmjs.com/package/vue-js-modal
      },
      closeModal() {
        this.$modal.hide('target-race'); // npmjs.com/package/vue-js-modal
        this.clearRaceForm()
      },
      deleteRace(raceID) {
        console.log(raceID)
        axios.delete('/api/targetraces/'.concat(raceID.toString()).concat('/'))
          .then(res => {
            console.log(res)
            this.getTargetRaces() // Refresh the list of races after deleting one
            this.$modal.hide('target-race'); // npmjs.com/package/vue-js-modal
          })
          .catch(error => console.log(error))
      },
      clearRaceForm() {
        this.raceName = ''
        this.raceDate = ''
        this.raceType = ''
        this.raceDistance = null
        this.distanceUnits = ''
        this.hours = null
        this.minutes = null
        this.seconds = null
        this.totalTime = null
        // this.overallRank = null
        // this.overallCompetitors = null
        // this.ageRank = null
        // this.ageCompetitors = null
        this.raceLink = ''
        // this.resultsLink = ''
        this.notes = ''

        this.editing = false
      }
    },
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/myrundash/dashboard/TargetRaces.vue